export class M3PImpuestos{
    public Porcentaje:number;
    public Valor:number;
    public LimiteOpuesto:number;
    public CodImpuesto:string;
    public Base:number;
}
